import Repository from './Repository';
const resource = '/banners';

export default {
  getMilePage() {
    return Repository.get(`${resource}/page/point`);
  }
};
